<template>
  <div class="payment">
    <div class="header">一户一码</div>
    <div class="main">
      <div class="nav">
        <div class="headline">{{ marketName }}</div>
        <div class="navHeader">
          <div class="sculpture">
            <img :src="headImg" alt="" class="sculpture_png" v-if="headImg" />
            <div v-else>
              <img src="../assets/images/boy.png" alt="" class="sculpture_png" v-if="sex == 0" />
              <img src="../assets/images/girl.png" alt="" class="sculpture_png" v-else />
            </div>
          </div>
          <div class="name">
            <div class="merchant">
              <span>{{ name }}</span>
              <img src="../assets/images/boys.png" alt="" class="boys_png" v-if="sex == 0" />
              <img src="../assets/images/girls.png" alt="" class="boys_png" v-else />
            </div>
            <div class="stalls">
              <div class="stall" v-if="stalls">
                摊位:
                <span>{{ stalls }}</span>
                <!-- <span v-for="(item,index) in stallCodeSet" :key="index"> {{ item }}<span v-if="stallCodeSet.length>1">;</span> </span>  -->
              </div>
              <div class="stall" v-if="mobile">
                <!-- <div class="stall"> -->
                <img src="../assets/images/phones.png" alt="" class="phones_png" />
                <span>{{ mobile }}</span>
                <!-- <span>1111111</span> -->
              </div>
            </div>
            <div class="level">
              <span class="level_word">信用等级：</span>
              <div v-for="(item, index) in starLevel" :key="index">
                <img src="../assets/images/star.png" alt="" class="star_png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="price">
        <div class="list">
          <div class="box" v-for="(item, index) in list" :key="index" @click="Jump(item.id)">
            <img :src="item.png" alt="" class="list_png" />
            <div class="word">
              <img :src="item.card" alt="" class="list_card" />
              <div class="tit">
                {{ item.tit }}
                <img src="../assets/images/right.png" alt="" class="right_png" />
              </div>
              <div class="list_word">{{ item.word }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMerchant } from "@/api/home"
// const defaultqueryParams = {
//   pageNum: 1,
//   pageSize: 10,
//   name: null,
// };
export default {
  data() {
    return {
      list: [
        { id: "1", tit: "商户证件", png: require("../assets/images/pg1.png"), word: "营业执照、健康证", card: require("../assets/images/card1.png") },
        { id: "2", tit: "食品检测", png: require("../assets/images/pg2.png"), word: "食品安全检测信息", card: require("../assets/images/card2.png") },
        { id: "3", tit: "管理人员", png: require("../assets/images/pg3.png"), word: "市场管理人员信息", card: require("../assets/images/card3.png") },
        { id: "4", tit: "点赞建议", png: require("../assets/images/pg4.png"), word: "我要建议/我要点赞", card: require("../assets/images/card4.png") },
      ],
      marketName: "",
      name: "",
      mobile: "",
      headImg: "",
      starLevel: "",
      sex: "",
      stallCodeSet: [],
      merId: "",
      stalls: "",
      tenantId: "",
    }
  },
  mounted() {
    // alert(window.location.href)
    // let geturl = "http://nm.zhihuinongmao.net/householdcode?id=s9205013" // http://localhost:8000/collection/businessprocessing/test?route=Test&routeTitle=Test&payerName=缴款人&outTradeNo=订单编号&oriAmt=支付金额
    let geturl = window.location.href
    let getPath = geturl.split("#/")[0]
    let getqyinfo = getPath.split("?")[1] //route=Test&routeTitle=Test&payerName=缴款人&outTradeNo=订单编号&oriAmt=支付金额  截取到参数部分
    let getqys = new URLSearchParams(getqyinfo) //将参数放在URLSearchParams函数中
    this.merId = getqys.get("id") // 缴款人
    this.trade_no = getqys.get("trade_no") //订单编号

    this.getAll()
  },
  methods: {
    getAll() {
      // console.log(this.merId, '2')
      getMerchant({
        merId: this.merId,
      })
        .then(res => {
          this.marketName = res.data.marketName
          this.name = res.data.name
          this.sex = res.data.sex
          this.mobile = res.data.mobile
          this.headImg = res.data.headImg
          this.starLevel = res.data.starLevel
          this.stalls = res.data.stalls
          this.tenantId = res.data.tenantId
        })
        .catch(err => {
          //  alert(err)
        })
    },
    Jump(e) {
      if (e == 1) {
        this.$router.push({
          name: "Document",
          params: {
            merId: this.merId,
          },
        })
      } else if (e == 2) {
        this.$router.push({
          name: "Foodsafety",
          params: {
            tenantId: this.tenantId,
          },
        })
      } else if (e == 3) {
        this.$router.push({
          name: "Marketmanagement",
          params: {
            tenantId: this.tenantId,
          },
        })
      } else if (e == 4) {
        this.$router.push({
          name: "Complaint",
          params: {
            merId: this.merId,
          },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
//@import "../assets/styles/home.less";
.payment {
  .header {
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.32rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 400;
    color: #3e3e3e;
    background: #ffffff;
    opacity: 1;
  }

  .main {
    box-sizing: border-box;

    // padding:0 0.24rem;
    .nav {
      box-sizing: border-box;
      background-image: url("@/assets/images/nav_bg.png");
      width: 100%;
      height: 4.22rem;

      .headline {
        font-size: 0.36rem;
        font-family: eryaxindahei-Regular, eryaxindahei;
        font-weight: 400;
        color: #ffffff;
        height: 1.2rem;
        line-height: 1.2rem;
      }

      .navHeader {
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 0 0.36rem;

        // margin-top:0.66rem ;
        .sculpture {
          .sculpture_png {
            width: 1.76rem;
            height: 1.76rem;
            border-radius: 50%;
            border: 0.04rem solid #ffffff;
          }
        }

        .name {
          margin-left: 0.32rem;

          .merchant {
            //height: 0.6rem;
            font-size: 0.48rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            margin-top: 0.12rem;
            text-align: left;

            //line-height:0.6rem;
            .boys_png {
              width: 0.36rem;
              height: 0.36rem;
              margin-left: 0.15rem;
            }
          }

          .stalls {
            display: flex;
            justify-content: flex-start;
            margin-top: 0.06rem;

            :nth-child(2) {
              margin-left: 0.1rem;
            }

            .stall {
              // width: 1.78rem;
              height: 0.52rem;
              line-height: 0.52rem;
              // background-image: url("@/assets/images/org.png");
              background-size: 100% 100%;
              font-size: 0.24rem;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 400;
              color: #fff;
              margin-top: 0.15rem;
              box-sizing: border-box;
              padding: 0rem 0.2rem;
              // height: 0.48rem;
              background: rgba(255, 255, 255, 0.3);
              border-radius: 0.24rem;

              .phones_png {
                width: 0.28rem;
                height: 0.28rem;
                vertical-align: middle;
                margin-top: -0.05rem;
              }
            }
          }

          .level {
            display: flex;
            justify-content: flex-start;
            margin-top: 0.25rem;

            .level_word {
              font-size: 0.28rem;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }

            .star_png {
              width: 0.32rem;
              height: 0.32rem;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .price {
      margin-top: -0.32rem;
      //height:7.5rem;
      background: #ffffff;
      border-radius: 0.32rem 0.32rem 0rem 0rem;
      opacity: 1;
      box-sizing: border-box;
      padding: 0.4rem 0.44rem 0;

      .list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .box {
          width: 4.4rem;
          height: 3rem;
          position: relative;
          margin-top: 0.42rem;

          .list_png {
            width: 100%;
            height: 3rem;
            // position: absolute;
            // left: 0;
            // top: 0;
            // z-index: 1;
          }
    
          .word {
            position: absolute;
            left: 0.4rem;
            top: 0.48rem;
            z-index: 1;
            text-align: left;

            .list_card {
              width: 0.56rem;
              height: 0.56rem;
            }

            .tit {
              font-size: 0.45rem;
              font-weight: bold;
              color: #ffffff;
              font-family: eryaxindahei-Regular, eryaxindahei;
              height: 0.8rem;
              line-height: 0.8rem;
              margin-top: 0.2rem;
              .right_png {
                width: 0.18rem;
                height: 0.4rem;
                margin-left: 0.1rem;
              }
            }

            .list_word {
              font-size: 0.26rem;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.74);
              margin-top: 0.05rem;
            }
          }
        }
      }
    }
  }
}
</style>
